import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import { endOfMonth } from 'date-fns';
import { useAlert } from 'react-alert';
import TablePagination from '@material-ui/core/TablePagination';
import { upperCase } from 'lodash';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));

const screenCode = 'CHEQUECUSTOMERREPORT';

export default function ChequeCustomerReport(props) {
  const [title, setTitle] = useState("Cheque Customer Report");
  const classes = useStyles();
  const [chequeCustomerDetail, setChequeCustomerDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    year: '',
    month: ''
  });
  const [FactoryList, setFactoryList] = useState([]);
  const [GroupList, setGroupList] = useState([]);
  const [routes, setRoutes] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [selectedDatePDF, setSelectedDatePDF] = useState();
  const [chequeCustomerData, setChequeCustomerData] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const navigate = useNavigate();
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routes: "0",
    monthName: '',
    year: '',
    monthName: ''
  })
  const componentRef = useRef();
  const [totalAmount, setTotalAmount] = useState(0);
  const [maxDate, setMaxDate] = useState(new Date());
  const [searchStarted, setSearchStarted] = useState(false);
  const alert = useAlert();
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);

  let date = new Date(selectedDate);
  let newSelectedMonth = upperCase(date.toLocaleString('default', { month: 'long' }));
  let newSelectedYear = date.getFullYear();

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    getFactoriesForDropdown();
  }, [chequeCustomerDetail.groupID]);

  useEffect(() => {
    trackPromise(getRoutesByFactoryID())
  }, [chequeCustomerDetail.factoryID]);

  useEffect(() => {
    trackPromise(checkISBalancePaymentCompleted())
  }, [chequeCustomerDetail.groupID, chequeCustomerDetail.factoryID]);

  useEffect(() => {
    if (chequeCustomerDetail.factoryID > 0 && chequeCustomerDetail.groupID > 0) {
      trackPromise(GetBalancePaymentYearMonthForDropDown());
    }
  }, [chequeCustomerDetail.factoryID, chequeCustomerDetail.groupID]);

  useEffect(() => {
    setChequeCustomerDetail((prev) => ({
      ...prev,
      routeID: "0"
    }));
  }, [chequeCustomerDetail.factoryID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCHEQUECUSTOMERREPORT');
    if (isAuthorized === undefined) navigate('/404');
    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: permissions.find(p => p.permissionCode == 'GROUPDROPDOWN') !== undefined,
      isFactoryFilterEnabled: permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN') !== undefined,
    });
    setChequeCustomerDetail({
      ...chequeCustomerDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(chequeCustomerDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(chequeCustomerDetail.factoryID);
    setRoutes(routeList);
  }

  async function checkISBalancePaymentCompleted() {
    const response = await services.CheckISBalancePaymentCompleted(chequeCustomerDetail.groupID, chequeCustomerDetail.factoryID);
    const bDate = moment(response.data.lastBalancePaymentSchedule, moment.defaultFormat).toDate();
    setMaxDate(endOfMonth(bDate));
  }

  async function GetBalancePaymentYearMonthForDropDown() {
    var response = await services.GetBalancePaymentYearMonth(chequeCustomerDetail.groupID, chequeCustomerDetail.factoryID);
    const selectedDate = new Date(response.applicableYear, response.applicableMonth - 1);
    setSelectedDate(selectedDate);
    setSelectedDatePDF(response);
  };

  async function GetDetails() {
    let total = 0;
    const model = {
      groupID: parseInt(chequeCustomerDetail.groupID),
      factoryID: parseInt(chequeCustomerDetail.factoryID),
      routeID: parseInt(chequeCustomerDetail.routeID),
      applicableMonth: (selectedDate.getMonth() + 1).toString(),
      applicableYear: selectedDate.getFullYear().toString()
    }
    getSelectedDropdownValuesForReport(model);
    const customerData = await services.GetChequeCustomerDetails(model);
    if (customerData.statusCode == "Success" && customerData.data != null) {
      setChequeCustomerData(customerData.data);
      customerData.data.forEach(x => total += parseFloat(x.amount));
      setTotalAmount(total);
      customerData.data.length == 0 ? alert.error("NO RECORDS TO DISPLAY") : alert.success("Success");
      createDataForExcel(customerData.data);
    }
    else alert.error("Error");
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array != null) {

      array.map(x => {
        var vr =
        {
          'Route': x.routeName,
          'Reg No': x.registrationNumber,
          'Customer Name': x.name,
          'Amount (Rs)': x.amount,
        };
        res.push(vr);
      });
    }
    return res;
  }

  async function createFile() {
    const file = await createDataForExcel(chequeCustomerData);
    const settings = {
      sheetName: 'Cheque Customer Details Report',
      fileName: `Cheque Customer Details Report - ${selectedSearchValues.factoryName} - BOUGHT LEAF CHEQUE PAYMENT FOR THE MONTH OF ${newSelectedMonth} - ${newSelectedYear}`,
      writeOptions: {}
    }

    file.push({});
    let total = {
      "Route": "Total",
      "Amount (Rs)": totalAmount
    }
    file.push(total)
    file.push({});

    let filterData = {
      "Route": "Group: " + selectedSearchValues.groupName,
      "Reg No": "Factory: " + selectedSearchValues.factoryName,
      "Customer Name": selectedSearchValues.routeName !== undefined ? "Route: " + selectedSearchValues.routeName : "Route: All Routes",
    }
    file.push(filterData);

    let filterDate = {
      "Route": "Month: " + newSelectedMonth,
      "Reg No": "Year: " + newSelectedYear
    }
    file.push(filterDate);

    let dataA = [{ sheet: 'Cheque Customer Details Report', columns: Object.keys(file[0] || {}).map(k => ({ label: k, value: k })), content: file }];
    xlsx(dataA, settings);
  }

  function generateDropDownMenu(data) {
    return Object.entries(data || {}).map(([key, value]) => <MenuItem key={key} value={key}>{value}</MenuItem>);
  }

  function handleChange(e) {
    if([e.target.name] == 'groupID'){
      setChequeCustomerDetail({ ...chequeCustomerDetail, [e.target.name]: e.target.value, factoryID: 0, routeID: 0 });
    } else {
      setChequeCustomerDetail({ ...chequeCustomerDetail, [e.target.name]: e.target.value });
    }
    setChequeCustomerData([]);
  }

  function handleDateChange(date) {
    const monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOMBER", "NOVEMBER", "DECEMBER"];
    setSelectedSearchValues({ ...selectedSearchValues, monthName: monthNames[date.getMonth()] });
    setChequeCustomerDetail({ ...chequeCustomerDetail, month: (date.getMonth() + 1).toString(), year: date.getFullYear().toString() });
    setSelectedDate(date);
    setSearchStarted(true);
    setChequeCustomerData([]);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({ ...selectedSearchValues, groupName: GroupList[searchForm.groupID], factoryName: FactoryList[searchForm.factoryID], routeName: routes[searchForm.routeID], month: searchForm.month, year: searchForm.year });
  }

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const getPageMargins = () => {
    return `@media print {
      @page {
        size: A4 landscape !important;
        margin: 50px 24px 56px 24px !important;
        background-color: white !important;
      }
      body {
        transform: scale(1);
        transform-origin: top left;
        background-color: white !important;
        width: 100%;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
    }`;
  };

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{ groupID: chequeCustomerDetail.groupID, factoryID: chequeCustomerDetail.factoryID }}
            validationSchema={Yup.object().shape({ 
              groupID: Yup.number().required('Group is required').min(1, 'Group is required'), 
              factoryID: Yup.number().required('Factory is required').min(1, 'Factory is required') })}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={
                      <Grid container spacing={1}>
                        <Grid item md={10} xs={12}>{title}</Grid>
                      </Grid>
                    } />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink>Group *</InputLabel>
                            <TextField select fullWidth error={Boolean(touched.groupID && errors.groupID)}
                              helperText={touched.groupID && errors.groupID} name="groupID" onBlur={handleBlur}
                              onChange={handleChange} value={chequeCustomerDetail.groupID} variant="outlined"
                              disabled={!permissionList.isGroupFilterEnabled} size='small'>
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink>Factory *</InputLabel>
                            <TextField select fullWidth error={Boolean(touched.factoryID && errors.factoryID)}
                              helperText={touched.factoryID && errors.factoryID} name="factoryID" onBlur={handleBlur}
                              onChange={handleChange} value={chequeCustomerDetail.factoryID} variant="outlined"
                              disabled={!permissionList.isFactoryFilterEnabled} size='small'>
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink>Route</InputLabel>
                            <TextField select fullWidth name="routeID" onChange={handleChange}
                              value={chequeCustomerDetail.routeID} variant="outlined" size='small'>
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker autoOk variant="inline" openTo="month" views={["year", "month"]}
                                label="Year and Month *" helperText="Select applicable month" value={selectedDate}
                                maxDate={maxDate} onChange={handleDateChange} />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Grid container justify="flex-end">
                          <Box pt={2}>
                            <Button color="primary" variant="contained" type='submit' onClick={() => trackPromise(GetDetails())}>
                              Search
                            </Button>
                          </Box>
                        </Grid>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <Box minWidth={1050}>
                          {chequeCustomerData.length > 0 ? (
                            <TableContainer>
                              <Table size="small" style={{ border: '1px solid #ccc', borderCollapse: 'collapse' }}>
                                <TableHead>
                                  <TableRow>
                                    <TableCell align="center" style={{ border: '1px solid #ccc', fontSize: '14px' }}>Route Name</TableCell>
                                    <TableCell align="center" style={{ border: '1px solid #ccc', fontSize: '14px' }}>Reg No</TableCell>
                                    <TableCell align="center" style={{ border: '1px solid #ccc', fontSize: '14px' }}>Customer Name</TableCell>
                                    <TableCell align="center" style={{ border: '1px solid #ccc', fontSize: '14px' }}>Amount (Rs)</TableCell>
                                  </TableRow>
                                </TableHead>
                                {chequeCustomerData.slice(page * limit, page * limit + limit).map((data, index) => (
                                  <TableBody>
                                    <TableRow key={index}>
                                      <TableCell align="left" style={{ border: '1px solid #ccc', fontSize: '14px' }}>{data.routeName}</TableCell>
                                      <TableCell align="left" style={{ border: '1px solid #ccc', fontSize: '14px' }}>{data.registrationNumber}</TableCell>
                                      <TableCell align="left" style={{ border: '1px solid #ccc', fontSize: '14px' }}>{data.name}</TableCell>
                                      <TableCell align="right" style={{ border: '1px solid #ccc', fontSize: '14px' }}>{(data.amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                ))}

                                <TableRow>
                                  <TableCell align="left" style={{ border: '1px solid #ccc', fontSize: '14px' }}><b>Total</b></TableCell>
                                  <TableCell align="left" style={{ border: '1px solid #ccc', borderRight: 'none', fontSize: '14px' }}></TableCell>
                                  <TableCell align="left" style={{ border: '1px solid #ccc', borderLeft: 'none', fontSize: '14px' }}></TableCell>
                                  <TableCell align="right" style={{ border: '1px solid #ccc', fontSize: '14px' }}><b>{(totalAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                </TableRow>
                              </Table>
                              <TablePagination
                                component="div"
                                count={chequeCustomerData.length}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handleLimitChange}
                                page={page}
                                rowsPerPage={limit}
                                rowsPerPageOptions={[5, 10, 25]}
                              />
                            </TableContainer>
                          ) : null}
                        </Box>
                      </CardContent>
                      {chequeCustomerData.length > 0 && (
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button color="primary" variant="contained" style={{ marginRight: '1rem' }} className={classes.colorRecord} onClick={createFile} size='small'>
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle="Cheque Customer Details Report"
                            trigger={() => <Button color="primary" variant="contained" style={{ marginRight: '1rem' }} className={classes.colorCancel} size='small'>PDF</Button>}
                            content={() => componentRef.current}
                            pageStyle={getPageMargins()}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef} searchData={selectedSearchValues} searchDate={chequeCustomerDetail}
                              chequeCustomerData={chequeCustomerData} total={totalAmount} newSelectedMonth={newSelectedMonth} newSelectedYear={newSelectedYear} />
                          </div>
                        </Box>
                      )}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}